import React, { useEffect, useState } from "react";
import { Button, Card, Input, Switch, Typography } from "antd";
import axios from "axios";
import { token, url } from "../../Functionalities/Config";
import { showMessage } from "../../Functionalities/Functions";
import { RIDER_ALERT_MAX_LENGTH, riderAlertError, riderAlertUrl } from "./riderAlert";

const notify = (text, type) =>
  showMessage(text, type, type === "success" ? "Success!" : "Error!", "top", "top-right", 0);

const RiderAlertCard = ({ franchiseId }) => {
  const [message, setMessage] = useState("");
  const [active, setActive] = useState(false);
  const [updatedAt, setUpdatedAt] = useState(null);
  const [saving, setSaving] = useState(false);

  const apply = (alert) => {
    setMessage(alert.message || "");
    setActive(Boolean(alert.alert_active));
    setUpdatedAt(alert.updated_at);
  };

  useEffect(() => {
    axios
      .get(riderAlertUrl(url, franchiseId), { headers: { Authorization: token } })
      .then((response) => {
        if (response.data?.Status) apply(response.data.Message);
      })
      .catch(() => {
        // The card stays empty; saving still works and reports its own error.
      });
  }, [franchiseId]);

  const save = () => {
    const error = riderAlertError({ message, active });
    if (error) {
      notify(error, "danger");
      return;
    }
    const data = new FormData();
    data.append("message", message.trim());
    data.append("alert_active", active ? "true" : "false");
    if (franchiseId) data.append("franchise_id", franchiseId);

    setSaving(true);
    axios
      .put(riderAlertUrl(url, null), data, { headers: { Authorization: token } })
      .then((response) => {
        if (response.data?.Status) {
          apply(response.data.Message);
          notify(response.data.Message.alert_active ? "Riders now see this alert" : "Rider alert is off", "success");
        } else {
          notify(response.data?.Error || "Could not save the rider alert", "danger");
        }
      })
      .catch((err) => notify(err?.response?.data?.Error || "Could not save the rider alert", "danger"))
      .finally(() => setSaving(false));
  };

  return (
    <Card
      size="small"
      title="Rider alert"
      style={{ margin: "0 0 16px" }}
      extra={
        <Switch
          checked={active}
          onChange={setActive}
          checkedChildren="On"
          unCheckedChildren="Off"
          aria-label="Show the rider alert"
        />
      }
    >
      <Typography.Paragraph type="secondary" style={{ marginBottom: 8 }}>
        While it is on, your delivery partners see this message above their New and Accepted order lists.
      </Typography.Paragraph>
      <Input.TextArea
        value={message}
        onChange={(event) => setMessage(event.target.value)}
        maxLength={RIDER_ALERT_MAX_LENGTH}
        showCount
        autoSize={{ minRows: 2, maxRows: 5 }}
        placeholder="Due to heavy rain every order will have an extra surge of Rs.10"
        aria-label="Rider alert message"
      />
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 12 }}>
        <Button type="primary" onClick={save} loading={saving}>
          Save
        </Button>
        {updatedAt && (
          <Typography.Text type="secondary">
            Last saved {new Date(updatedAt).toLocaleString()}
          </Typography.Text>
        )}
      </div>
    </Card>
  );
};

export default RiderAlertCard;
